module.exports = __webpack_public_path__ + "static/media/r1.df077f72.jpg";